import styled from 'styled-components';

export const SActionItemTabWrapper = styled.div`
  & .ant-table-footer {
    padding: 0;
    background-color: transparent;
  }
`;
